<template>
  <div>
    <v-card>
      <v-toolbar color="#66b401" class="text-h6" dark>{{ title }}</v-toolbar>
      <v-card-text>
        <div class="body-1 font-weight-bold pa-2">
          Upload your custom projections in .csv format. <br />
          <i class="body-2 text--yellow">
            keep this in mind when uploading your .csv file:
          </i>
        </div>

        <v-banner color="#81C784" rounded class="Info-banner">
          <ul class="text-body-1 white--text">
            <li>Your csv file should have headers in the first row.</li>
            <li>
              Your upload must either use the headers from our download template
              OR consist of at least two columns: a ”name“ and ”fpts“ or
              ”proj_points“ column.
            </li>
            <li>
              Our software will help you match names when they aren't an exact
              match.
            </li>
            <li>
              You have a limit of 5 projection files per site/sport combination.
            </li>
          </ul>
        </v-banner>
      </v-card-text>
      <v-card-actions class="justify-end"> </v-card-actions>
      <v-row justify="center" class="mx-auto">
        <v-col md="6">
          <v-file-input
            v-model="files"
            small-chips
            multiple
            outlined
            dense
            label="Import .csv file"
          ></v-file-input>
        </v-col>

        <v-col md="4">
          <v-btn
            color="#00C853"
            class="white--text"
            depressed
            @click="emitEvent"
          >
            Import
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "uploadProjection",
  props: {
    title: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      files: [],
    };
  },

  methods: {
    emitEvent() {
      this.$emit("import", this.files);
    },
  },
};
</script>

<style></style>
